import { F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'

export const url = {
  transaction: `/transaction`,
  rechargePromotion: `/pakage-recharge`
}

export async function listRechargePromotionHistory(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.transaction}/transactions?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function listRechargePromotion(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.rechargePromotion}?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function rechargePromotionAdd(body) {
  const response = await apiCMSWithToken.post(`${url.rechargePromotion}`, body)
  return response
}
export async function rechargePromotionUpdate(body, id) {
  const response = await apiCMSWithToken.put(
    `${url.rechargePromotion}/${id}`,
    body
  )
  return response
}

export async function rechargePromotionDetail(id) {
  try {
    const response = await apiCMSWithToken.get(`${url.rechargePromotion}/${id}`)

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function rechargePromotionDelete(id) {
  try {
    const response = await apiCMSWithToken.delete(
      `${url.rechargePromotion}/${id}`
    )
    // const response = await apiCMSWithToken.delete(`${url.pakages}`, {
    //   data: body
    // })
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export default {
  listRechargePromotionHistory,
  listRechargePromotion,
  rechargePromotionAdd,
  rechargePromotionUpdate,
  rechargePromotionDetail,
  rechargePromotionDelete
}
